
<template>
  <authorization
    permissionKey="configuration_medical_report_template"
    can="read"
  >
    <v-container fluid>
      <v-row>
        <v-col class="text-h3 gray--text"> Modelos de Relatório Médico</v-col>
      </v-row>
      <!-- <v-data-table :headers="headers" :items="medicalReportTemplates" sort-by="name" > -->

      <v-data-table :headers="headers" :items="filteredMedicalReportTemplates" sort-by="name" >
        <template v-slot:top>
          <v-toolbar flat>
          <v-text-field
          label="Busca"
          v-model="filter"
          outlined
          dense
          hide-details
          clearable
          append-icon="eva-search-outline"
          />
          <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="800px" @click:outside="close">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="light-blue" dark v-bind="attrs" v-on="on">
                  Novo modelo
                </v-btn>
              </template>

              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container fluid>
                    <v-row dense>
                      <v-col>
                        <v-text-field
                          outlined
                          dense
                          hide-details
                          v-model="editedItem.name"
                          label="Nome"
                        />
                      </v-col>
                    </v-row>

                    <v-row dense>
                      <v-col>
                        <RichText v-model="editedItem.description" />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">
                    Cancelar
                  </v-btn>

                  <v-btn color="blue darken-1" text @click="save">
                    Salvar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <template v-slot:item.actions="{ item }">
          <authorization
            permissionKey="configuration_medical_report_template"
            can="save"
            v-slot:default="{ authorization }"
          >
            <v-icon
              v-if="authorization"
              small
              class="mr-2"
              @click="editItem(item)"
            >
              eva-edit-outline
            </v-icon>
          </authorization>

          <authorization
            permissionKey="configuration_medical_report_template"
            can="delete"
            v-slot:default="{ authorization }"
          >
            <v-icon v-if="authorization" small @click="deleteItem(item)">
              eva-trash-outline
            </v-icon>
          </authorization>
        </template>

        <template v-slot:no-data>
          <v-alert color="orange" outlined text type="info">
            Não há modelos cadastrados
          </v-alert>
        </template>
      </v-data-table>
    </v-container>
  </authorization>
</template>

<script>
export default {
  name: "MedicalReportTemplateList",
  props: {
    medicalReportTemplate: Object,
  },
  data() {
    return {
      dialog: null,
      editedItem: {},
      defaultItem: {},
      editedIndex: -1,
      filter: "",
      headers: [
        { text: "Name", value: "name" },
        { text: "Ações", value: "actions", sortable: false, align: "end" },
      ],
      medicalReportTemplates: [],
    };
  },
  mounted() {
    this.medicalReportTemplates = [];
  },
  watch: {
    medicalReport() {
      this.medicalReportTemplates = [];
    },
  },
  apollo: {
    medicalReportTemplates: {
      query: require("@/graphql/medical_report/medical_report_templates.gql"),
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Novo Modelo" : "Editar Modelo";
    },
    filteredMedicalReportTemplates() {
    let filtered = this.lodash.filter(this.medicalReportTemplates, item => item.name.includes(this.filter));
      return filtered
    },
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.medicalReportTemplates.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      if (
        confirm(
          "Você realmente deseja deletar esse modelo de relatório médico?"
        )
      ) {
        this.apolloMutate({
          mutation: require("@/graphql/medical_report/delete_medical_report_template.gql"),
          variables: {
            medicalReportTemplateId: item.id,
          },
        }).then(() => {
          this.refreshList();
          this.$store.dispatch("createNotification", {
            message: "Modelo do relatório médico deletado com sucesso.",
            type: "success",
          });
        });
      }
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      this.apolloMutate({
        mutation: require("@/graphql/medical_report/save_medical_report_template.gql"),
        variables: {
          medicalReportTemplateId: this.lodash.get(this.editedItem, "id", ""),
          name: this.editedItem.name,
          description: this.editedItem.description,
        },
      }).then(() => {
        this.refreshList();

        this.$store.dispatch("createNotification", {
          message: "Cadastro salvo com sucesso.",
          type: "success",
        });
      });

      this.close();
    },
    refreshList() {
      return this.$apollo.queries.medicalReportTemplates.refetch();
    },
  },
};
</script>

<style lang="scss" scoped></style>

